import * as m from "mithril";
import { PaymentMethodDTO, PaymentOptionDTO } from "../../apiclient/ApiDtos";

function PaymentOptionCard(): m.Component<{
    paymentOption: PaymentOptionDTO ,
    onSelected: (option: PaymentOptionDTO) => void
}> {
    return {
        view(vnode) {
            let paymentOption: PaymentOptionDTO = vnode.attrs.paymentOption;
            let paymentMethod: PaymentMethodDTO = paymentOption.paymentMethod;

            return m("div.mb-2", {
                class: "card card-clickable"
            }, [
                m("div.card-body", {
                    onclick: (event) => {
                        event.preventDefault();
                        vnode.attrs.onSelected(paymentOption);
                    }
                },
                    [
                        m("div", { class: "row" }, [
                            m("div", { class: "col-6" }, [
                                m("img.img-logo", {
                                    class: "align-middle img-fluid",
                                    src: paymentOption.paymentMethod.logoUrl,
                                })
                            ]),
                            m("div", { class: "col-6 text-right text-end" }, [
                                m("div", paymentMethod.title),
                                m("div", { class: "text-muted text-right" },
                                    m("small", {}, "MMK")
                                )
                            ])
                        ])
                    ]
                ),

            ])
        }
    }
}

export default PaymentOptionCard;

